/* SAVIELLA Rubbellos – gehaertete Fassung */
(function () {
  'use strict';

  var root = document.querySelector('[data-srv-scratch]');
  if (!root) return;
  if (root.dataset.srvInit === '1') return;
  root.dataset.srvInit = '1';

  var KEY = 'srv_scratch_v1';
  var AGAIN = 7 * 24 * 60 * 60 * 1000; /* nach 7 Tagen wieder zeigen */

  function q(sel) { return root.querySelector(sel); }

  var delayRaw = parseInt(root.dataset.delay || '2', 10);
  var cfg = {
    delay: (isNaN(delayRaw) ? 2 : Math.max(0, Math.min(60, delayRaw))) * 1000,
    code: (root.dataset.code || 'WILLKOMMEN25').trim()
  };

  var modal = q('.srv-sc');
  var card = q('.srv-sc__card');
  var ticket = q('.srv-sc__ticket');
  var canvas = q('.srv-sc__canvas');
  var claim = q('.srv-sc__claim');
  var confetti = q('.srv-sc__confetti');
  var tab = q('.srv-sc__tab');
  var stepWin = q('[data-step="win"]');
  var stepDone = q('[data-step="done"]');
  var form = q('.srv-sc__form');
  var mail = q('#srv-sc-mail');
  var errBox = q('.srv-sc__err');

  if (!modal || !card || !ticket || !claim || !tab || !stepWin || !stepDone) return;

  var reduceMotion = false;
  try {
    reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  /* ---------- Speicher ---------- */
  function state() {
    try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; }
  }
  function save(o) {
    try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {}
  }
  function patch(k, v) { var s = state(); s[k] = v; save(s); }

  /* ---------- Oeffnen / Schliessen ---------- */
  var prevOverflow = null;
  var lastFocus = null;

  function isOpen() { return modal.classList.contains('is-open'); }

  function open() {
    if (isOpen()) return;
    lastFocus = document.activeElement;
    prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    tab.classList.remove('is-on');
    if (!revealed && stepDone.hidden) schedulePaint();
    setTimeout(function () {
      var x = q('.srv-sc__x');
      if (x) { try { x.focus({ preventScroll: true }); } catch (e) {} }
    }, 80);
  }

  function close() {
    if (!isOpen()) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = prevOverflow || '';
    tab.classList.add('is-on');
    var s = state();
    if (!s.claimed) {
      s.closed = true;
      s.closedAt = Date.now();
      save(s);
    }
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  function showDone() {
    stepWin.hidden = true;
    stepDone.hidden = false;
  }

  /* ---------- Rubbelflaeche ---------- */
  var ctx = null;
  var revealed = false;
  var drawing = false;
  var last = null;
  var paintedW = 0;
  var paintedH = 0;
  var paintTries = 0;
  var strokes = 0;
  var pixelCheckBroken = false;

  function canvasOk() {
    if (!canvas || !canvas.getContext) return false;
    try { return !!canvas.getContext('2d'); } catch (e) { return false; }
  }

  function schedulePaint() {
    paintTries = 0;
    tryPaint();
  }

  function tryPaint() {
    if (revealed) return;
    if (!canvasOk()) { reveal(true); return; }
    var r = ticket.getBoundingClientRect();
    if (r.width < 24 || r.height < 24) {
      paintTries++;
      if (paintTries > 90) { reveal(true); return; }
      requestAnimationFrame(tryPaint);
      return;
    }
    paint(r);
  }

  function paint(r) {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(r.width * dpr);
    canvas.height = Math.round(r.height * dpr);
    ctx = canvas.getContext('2d');
    if (!ctx) { reveal(true); return; }
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    paintedW = r.width;
    paintedH = r.height;
    strokes = 0;

    var g = ctx.createLinearGradient(0, 0, r.width, r.height);
    g.addColorStop(0, '#C8A66B');
    g.addColorStop(0.5, '#B08D57');
    g.addColorStop(1, '#9A7A49');
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, r.width, r.height);

    ctx.globalAlpha = 0.14;
    ctx.fillStyle = '#FFFDFA';
    for (var y = 18; y < r.height; y += 42) {
      for (var x = 18; x < r.width; x += 48) {
        var off = ((y / 42) % 2) * 24;
        if ((x + y) % 96 < 48) { moon(x + off, y, 8); } else { star(x + off, y, 5); }
      }
    }
    ctx.globalAlpha = 1;

    ctx.fillStyle = 'rgba(255,253,250,.95)';
    ctx.font = '600 12px Montserrat, system-ui, sans-serif';
    ctx.textAlign = 'center';
    ctx.fillText('H I E R   F R E I R U B B E L N', r.width / 2, r.height / 2 + 4);

    ctx.globalCompositeOperation = 'destination-out';
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.lineWidth = 42;
  }

  function moon(cx, cy, rad) {
    ctx.beginPath();
    ctx.arc(cx, cy, rad, 0, Math.PI * 2);
    ctx.arc(cx + rad * 0.55, cy - rad * 0.2, rad * 0.9, 0, Math.PI * 2, true);
    ctx.fill();
  }
  function star(cx, cy, rad) {
    ctx.beginPath();
    for (var i = 0; i < 8; i++) {
      var a = (Math.PI / 4) * i;
      var rr = i % 2 === 0 ? rad : rad * 0.38;
      ctx[i ? 'lineTo' : 'moveTo'](cx + Math.cos(a) * rr, cy + Math.sin(a) * rr);
    }
    ctx.closePath();
    ctx.fill();
  }

  function point(e) {
    var r = canvas.getBoundingClientRect();
    var sx = (paintedW && r.width) ? paintedW / r.width : 1;
    var sy = (paintedH && r.height) ? paintedH / r.height : 1;
    return { x: (e.clientX - r.left) * sx, y: (e.clientY - r.top) * sy };
  }

  function stroke(p) {
    if (last) {
      ctx.beginPath();
      ctx.moveTo(last.x, last.y);
      ctx.lineTo(p.x, p.y);
      ctx.stroke();
    }
    ctx.beginPath();
    ctx.arc(p.x, p.y, 21, 0, Math.PI * 2);
    ctx.fill();
    last = p;
    strokes++;
  }

  function onDown(e) {
    if (revealed || !ctx) return;
    drawing = true;
    last = null;
    if (e.pointerId !== undefined && canvas.setPointerCapture) {
      try { canvas.setPointerCapture(e.pointerId); } catch (err) {}
    }
    if (e.cancelable) e.preventDefault();
    stroke(point(e));
    checkProgress();
  }

  function onMove(e) {
    if (!drawing || revealed || !ctx) return;
    if (e.cancelable) e.preventDefault();
    var list = null;
    if (e.getCoalescedEvents) {
      try { list = e.getCoalescedEvents(); } catch (err) { list = null; }
    }
    if (list && list.length) {
      for (var i = 0; i < list.length; i++) stroke(point(list[i]));
    } else {
      stroke(point(e));
    }
    checkProgress();
  }

  function onUp() {
    drawing = false;
    last = null;
    if (!revealed && ctx) { lastCheck = 0; checkProgress(); }
  }

  var lastCheck = 0;
  function checkProgress() {
    if (revealed || !ctx) return;
    var now = Date.now();
    if (now - lastCheck < 140) return;
    lastCheck = now;

    if (pixelCheckBroken) {
      if (strokes > 70) reveal();
      return;
    }

    var w = canvas.width;
    var h = canvas.height;
    if (!w || !h) return;

    var clear = 0;
    var total = 0;
    try {
      var rows = 8;
      for (var r = 0; r < rows; r++) {
        var y = Math.floor((h - 1) * (r + 0.5) / rows);
        var d = ctx.getImageData(0, y, w, 1).data;
        for (var i = 3; i < d.length; i += 32) {
          total++;
          if (d[i] < 16) clear++;
        }
      }
    } catch (e) {
      pixelCheckBroken = true;
      if (strokes > 70) reveal();
      return;
    }

    if (total && clear / total > 0.32) reveal();
  }

  function markRevealed() {
    revealed = true;
    drawing = false;
    ticket.classList.add('is-open');
    claim.classList.add('is-open');
  }

  function reveal(silent) {
    if (revealed) return;
    markRevealed();
    patch('revealed', true);
    if (!silent && !reduceMotion) burst();
    if (mail) {
      setTimeout(function () {
        try { mail.focus({ preventScroll: true }); } catch (e) {}
        try { mail.scrollIntoView({ block: 'nearest' }); } catch (e) {}
      }, 420);
    }
  }

  if (canvas) {
    if (window.PointerEvent) {
      canvas.addEventListener('pointerdown', onDown);
      canvas.addEventListener('pointermove', onMove);
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
        canvas.addEventListener(ev, onUp);
      });
    } else {
      canvas.addEventListener('mousedown', onDown);
      canvas.addEventListener('mousemove', onMove);
      canvas.addEventListener('touchstart', function (e) {
        if (e.touches && e.touches[0]) onDown(e.touches[0]);
        if (e.cancelable) e.preventDefault();
      }, { passive: false });
      canvas.addEventListener('touchmove', function (e) {
        if (e.touches && e.touches[0]) { drawing = true; onMove(e.touches[0]); }
        if (e.cancelable) e.preventDefault();
      }, { passive: false });
      ['mouseup', 'mouseleave', 'touchend', 'touchcancel'].forEach(function (ev) {
        canvas.addEventListener(ev, onUp);
      });
    }
  }

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (revealed || drawing) return;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (revealed || drawing || !isOpen()) return;
      var r = ticket.getBoundingClientRect();
      if (r.width < 24) return;
      if (Math.abs(r.width - paintedW) < 2) return;
      paint(r);
    }, 220);
  });

  function burst() {
    if (!confetti || !confetti.getContext) return;
    var r = card.getBoundingClientRect();
    if (!r.width) return;
    var c;
    try { c = confetti.getContext('2d'); } catch (e) { return; }
    if (!c) return;

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    confetti.width = Math.round(r.width * dpr);
    confetti.height = Math.round(r.height * dpr);
    c.setTransform(dpr, 0, 0, dpr, 0, 0);

    var colors = ['#B08D57', '#C8A66B', '#2F3A32', '#E6E1D9', '#FFFDFA'];
    var glyphs = ['✦', '☭'];
    var bits = [];

    for (var i = 0; i < 70; i++) {
      bits.push({
        x: r.width / 2 + (Math.random() - 0.5) * 70,
        y: r.height * 0.42,
        vx: (Math.random() - 0.5) * 7,
        vy: Math.random() * -8 - 3,
        w: 4 + Math.random() * 5,
        h: 7 + Math.random() * 7,
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.3,
        col: colors[(Math.random() * colors.length) | 0],
        glyph: i % 9 === 0 ? glyphs[(Math.random() * glyphs.length) | 0] : null,
        life: 1
      });
    }

    var t0 = Date.now();
    (function frame() {
      c.clearRect(0, 0, r.width, r.height);
      var done = true;
      for (var i = 0; i < bits.length; i++) {
        var b = bits[i];
        b.vy += 0.3;
        b.x += b.vx;
        b.y += b.vy;
        b.rot += b.vr;
        b.life = Math.max(0, 1 - (Date.now() - t0) / 2200);
        if (b.life <= 0) continue;
        done = false;
        c.save();
        c.globalAlpha = b.life;
        c.translate(b.x, b.y);
        c.rotate(b.rot);
        if (b.glyph) {
          c.fillStyle = '#B08D57';
          c.font = '15px serif';
          c.textAlign = 'center';
          c.fillText(b.glyph, 0, 0);
        } else {
          c.fillStyle = b.col;
          c.fillRect(-b.w / 2, -b.h / 2, b.w, b.h);
        }
        c.restore();
      }
      if (!done) requestAnimationFrame(frame);
      else c.clearRect(0, 0, r.width, r.height);
    })();
  }

  var closeBtn = q('.srv-sc__x');
  if (closeBtn) closeBtn.addEventListener('click', close);

  var backdrop = q('.srv-sc__backdrop');
  if (backdrop) backdrop.addEventListener('click', close);

  tab.addEventListener('click', function () { open(); });

  var skip = q('.srv-sc__skip');
  if (skip) skip.addEventListener('click', function () { reveal(); });

  function focusables() {
    var all = modal.querySelectorAll('button, a[href], input:not([type="hidden"])');
    var out = [];
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.disabled) continue;
      var r = el.getBoundingClientRect();
      if (r.width > 0 && r.height > 0) out.push(el);
    }
    return out;
  }

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape' || e.keyCode === 27) { close(); return; }
    if (e.key === 'Tab') {
      var vis = focusables();
      if (!vis.length) return;
      var first = vis[0];
      var lastEl = vis[vis.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
    }
  });

  if (form) {
    form.addEventListener('submit', function (e) {
      if (form.dataset.sent === '1') { e.preventDefault(); return; }
      if (mail && mail.checkValidity && !mail.checkValidity()) return;
      form.dataset.sent = '1';
      var btn = form.querySelector('.srv-sc__btn');
      if (btn) { btn.disabled = true; btn.textContent = 'Wird aktiviert …'; }
      var s = state();
      s.revealed = true;
      s.pending = true;
      s.email = mail ? mail.value : '';
      save(s);
    });
  }

  var copy = q('.srv-sc__copy');
  if (copy) {
    copy.addEventListener('click', function () {
      var ok = false;
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(cfg.code);
          ok = true;
        }
      } catch (e) {}
      if (!ok) {
        try {
          var ta = document.createElement('textarea');
          ta.value = cfg.code;
          ta.setAttribute('readonly', 'readonly');
          ta.style.position = 'fixed';
          ta.style.top = '0';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          ta.setSelectionRange(0, cfg.code.length);
          document.execCommand('copy');
          document.body.removeChild(ta);
        } catch (e2) {}
      }
      copy.textContent = 'Code kopiert';
      setTimeout(function () { copy.textContent = 'Code kopieren'; }, 2000);
    });
  }

  window.addEventListener('pageshow', function (ev) {
    if (ev.persisted && !isOpen()) document.body.style.overflow = '';
  });

  var posted = root.dataset.posted === '1';
  var errored = root.dataset.error === '1';
  var s0 = state();
  var stale = s0.closed && (Date.now() - (s0.closedAt || 0) > AGAIN);

  if (posted) {
    s0.claimed = true;
    s0.pending = false;
    save(s0);
    showDone();
    open();
    if (!reduceMotion) setTimeout(burst, 350);
    return;
  }

  if (errored) {
    s0.pending = false;
    save(s0);
    markRevealed();
    if (errBox) errBox.hidden = false;
    if (mail && s0.email) mail.value = s0.email;
    open();
    return;
  }

  if (s0.claimed) {
    showDone();
    tab.classList.add('is-on');
    return;
  }

  if (s0.revealed) {
    markRevealed();
    if (mail && s0.email) mail.value = s0.email;
    if (s0.closed && !stale) { tab.classList.add('is-on'); return; }
    setTimeout(open, cfg.delay);
    return;
  }

  if (s0.closed && !stale) {
    tab.classList.add('is-on');
    return;
  }

  setTimeout(open, cfg.delay);
})();
